define('lq/events/actions/redirect',[
    'lq',
    './eventAction',
    'lq/util'
], function (lq, EventAction, util) {
    'use strict';

    function Redirect(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Redirect, EventAction);

    Redirect.typeName = 'Redirect';

    Redirect.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Redirect.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.redirect.type === 'Reload') {
            window.location.reload();
        } else if (this.isJumpToPrevious(this.eventData.redirect)) {
            this.piping.navigator.goToPrevious(this.getParameters());
            continuation();
        } else if (this.isJumpOutsideApplication(this.eventData.redirect)) {
            var targetUrl = this.getUrl(this.eventData.redirect);
            this.piping.url.openUrl(targetUrl, this.eventData.redirect.jumpToNewWindow);

            if (this.eventData.redirect.jumpToNewWindow) {
                continuation();
            } else {
                if (this.linkWillNotCauseNavigationToAnotherPage(targetUrl))
                    continuation();
                this.piping.busyIndicator.forceHide();
            }
        } else {
            this.piping.navigator.openAction(
                this.getActionId(this.eventData.redirect),
                this.piping.parameters.globals.getAll(),
                this.getLocalsForNextPage(this.eventData.redirect),
                this.eventData.redirect.jumpToNewWindow);
            if (this.eventData.redirect.jumpToNewWindow)
                this.piping.busyIndicator.forceHide();
        }
    };

    Redirect.prototype.isJumpToPrevious = function (redirect) {
        return redirect.type === 'Previous';
    };

    Redirect.prototype.isJumpOutsideApplication = function (redirect) {
        return redirect.url || redirect.applicationName || redirect.controllerAction;
    };

    Redirect.prototype.getUrl = function (redirect) {
        if (redirect.controllerAction) {
            var controllerActionUrl = lq.getTenantUrl('LicquidAction/' + redirect.controllerAction);
            return this.piping.url.prepare(controllerActionUrl, this.getParameters());
        }

        if (redirect.applicationName) {
            var applicationUrl = lq.getBaseUrl(lq.getTenantName() + '/' + redirect.applicationName + '/LicquidAction/Get/' + redirect.actionId);
            return this.piping.url.prepare(applicationUrl, this.getParameters());
        }

        if (redirect.url) {
            var url = redirect.isUrlFromParameter ? this.piping.parameters.getValue(redirect.url) : redirect.url;

            if (url.indexOf('@') !== -1) {
                if (this.isEmailLink(url))
                    return url;
                return 'mailto:' + url;
            }

            var locals = this.getLocalsForNextPage(this.eventData.redirect);
            if (url.indexOf('tel:') === -1)
                url = util.convertRelativeHyperlinkToHostName(url);

            if (_.keys(locals).length > 0)
                url = url + '?parameters=' + encodeURIComponent(JSON.stringify(locals));

            return url;
        }

        return undefined;
    };
    
    Redirect.prototype.getParameters = function () {
        var params = {};

        var globals = this.piping.parameters.globals.getAll();
        if (_.keys(globals).length > 0)
            params['globals'] = JSON.stringify(globals);

        var locals = this.getLocalsForNextPage(this.eventData.redirect);
        if (_.keys(locals).length > 0)
            params['parameters'] = JSON.stringify(locals);

        return params;
    };

    Redirect.prototype.linkWillNotCauseNavigationToAnotherPage = function (targetUrl) {
        targetUrl = targetUrl.toLowerCase();

        return targetUrl.indexOf('mailto:') === 0
            || targetUrl.indexOf('skype:') === 0
            || targetUrl.indexOf('tel:') === 0
            || targetUrl.indexOf('webcal:') === 0;
    };
    
    Redirect.prototype.getActionId = function (redirect) {
        if (redirect.actionId)
            return redirect.actionId;
        
        return this.piping.parameters.getValue(redirect.actionIdParameter);
    };

    Redirect.prototype.isEmailLink = function (targetUrl) {
        return targetUrl.toLowerCase().indexOf('mailto:') === 0;
    };

    Redirect.prototype.getLocalsForNextPage = function (redirect) {
        if (!redirect.jumpParameters)
            return {};

        var localsForNextPage = {};

        for (var i = 0; i < redirect.jumpParameters.length; i++) {
            var jumpParameter = redirect.jumpParameters[i];
            localsForNextPage[jumpParameter] = this.piping.parameters.locals.getValue(jumpParameter);
        }

        return localsForNextPage;
    };

    return Redirect;
});
